import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLogged: false,
  id: null,
  name: "",
  createdAt: "",
  updatedAt: "",
  email: "",
  photoUrl: "",
  role: "",
  phone: "",
  school: {
    id: null,
    schoolName: "",
    schoolSystem: "",
    logoUrl: "",
  },
  logo: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.isLogged = true;
      state.id = action.payload.id;
      state.createdAt = action.payload.createdAt;
      state.updatedAt = action.payload.updatedAt;
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.photoUrl = action.payload.photoUrl;
      state.role = action.payload.role;
      state.phone = action.payload.phone;
      state.school = {
        id: action.payload.school.id,
        schoolName: action.payload.school.schoolName,
        schoolSystem: action.payload.school.schoolSystem,
        logoUrl: action.payload.school.logoUrl,
      };
    },
    setLogo: (state, action) => {
      state.logo = action.payload;
    },
    removeUser: (state) => {
      state.isLogged = false;
      state.id = null;
      state.createdAt = "";
      state.updatedAt = "";
      state.name = "";
      state.email = "";
      state.photoUrl = "";
      state.role = "";
      state.phone = "";
      state.school = {
        id: null,
        schoolName: "",
        schoolSystem: "",
        logoUrl: "",
      };
      state.logo = null;
    },
  },
});

export const { setUser, removeUser, setLogo } = userSlice.actions;
export default userSlice.reducer;
